import React, { useState } from 'react';
import './WeedHurryCourier.css';
import CourierSubscriptionForm from '../components/CourierSubscriptionForm';

const WeedHurryCourier = () => {
  const [formData, setState] = useState({
    dispensaryName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zip: ''
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Simulate API request
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
    }, 1500);
    
    // In production, you would make an actual API call here
    // fetch('https://api.weedhurry.com/signup', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(formData),
    // })
    // .then(response => response.json())
    // .then(data => {
    //   setSubmitting(false);
    //   setSubmitted(true);
    // })
    // .catch(error => {
    //   setSubmitting(false);
    //   console.error('Error:', error);
    // });
  };

  return (
    <div className="wh-courier-container">
<header className="wh-header">
  <div className="wh-logo-container">
    <h1><strong>weedhurry</strong> <span className="wh-highlight">COURIER</span></h1>
    <p className="wh-tagline">On-demand delivery drivers for your dispensary</p>
  </div>
  <div className="wh-header-actions">
    <a href="/courier-request" className="wh-header-link">Request Courier</a>
    <a href="/courier-login" className="wh-login-button">Login</a>
  </div>
</header>
      
      <section className="wh-hero">
        <div className="wh-hero-content">
          <h2>Expand Your Delivery Reach Without The Overhead</h2>
          <p>Partner with Weedhurry to offer seamless delivery services to your customers without managing a delivery fleet.</p>
          
          <a href="/courier-request" className="wh-cta-button">Request Courier</a>
        </div>
        <div className="wh-hero-image">
          {/* Real image instead of placeholder */}
          <img 
            src="https://normlvt.org/wp-content/uploads/2022/11/pelican-cannabis-delivery-service.jpeg" 
            alt="Cannabis Delivery Service" 
            style={{ 
              width: '100%', 
              borderRadius: 'var(--border-radius)', 
              boxShadow: 'var(--box-shadow)' 
            }} 
          />
        </div>
      </section>
      
      <section className="wh-pricing">
        <div className="wh-pricing-header">
          <h2>Choose The Plan That Works For You</h2>
          <div className="wh-trial-banner">
            <span className="wh-trial-text">Two Flexible Options</span>
            <p>Select the plan that best fits your delivery volume and business needs</p>
          </div>
        </div>
        <div className="wh-pricing-details" style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <div className="wh-pricing-card">
            <h3>A La Carte</h3>
            <div className="wh-price">
              <span className="wh-price-amount">20%</span>
              <span className="wh-price-period">commission</span>
            </div>
            <p className="wh-price-description">Pay only when you need delivery service</p>
            <ul className="wh-price-features">
              <li>No monthly fees</li>
              <li>On-demand courier access</li>
              <li>30-minute guaranteed pickup time</li>
              <li>Real-time delivery tracking</li>
              <li>Customer satisfaction guarantee</li>
              <li>Perfect for low-volume deliveries</li>
            </ul>
            <a href="/courier-request" className="wh-price-button">Request Courier</a>
          </div>
          
          <div className="wh-pricing-card">
            <div className="wh-pricing-badge">Free 30-day Trial</div>
            <h3>Subscription</h3>
            <div className="wh-price">
              <span className="wh-price-amount">$79</span>
              <span className="wh-price-period">/month</span>
            </div>
            <p className="wh-price-description">Plus 15% commission on each delivery</p>
            <ul className="wh-price-features">
              <li>Unlimited access to courier network</li>
              <li>Reduced 15% commission rate</li>
              <li>30-minute guaranteed pickup time</li>
              <li>Real-time delivery tracking</li>
              <li>24/7 support for partners</li>
              <li>Ideal for high-volume deliveries</li>
            </ul>
            <a href="#subscription-form" className="wh-price-button">Subscribe Now</a>
            <p className="wh-price-note">Save money with higher delivery volume</p>
          </div>
        </div>
      </section>
      
      <section className="wh-benefits">
        <h2>Why Partner With WeedHurry?</h2>
        <div className="wh-benefits-grid">
          <div className="wh-benefit-card">
            <div className="wh-benefit-icon">🚚</div>
            <h3>Increased Revenue</h3>
            <p>Expand your delivery radius and fulfill more orders without additional staff.</p>
          </div>
          <div className="wh-benefit-card">
            <div className="wh-benefit-icon">⏱️</div>
            <h3>Quick Pickup</h3>
            <p>Drivers arrive within 30 minutes of request to ensure timely deliveries.</p>
          </div>
          <div className="wh-benefit-card">
            <div className="wh-benefit-icon">💰</div>
            <h3>Flexible Pricing</h3>
            <p>Choose between a la carte (20% commission) or subscription ($79/month with 15% commission).</p>
          </div>
          <div className="wh-benefit-card">
            <div className="wh-benefit-icon">📱</div>
            <h3>Real-time Updates</h3>
            <p>Track deliveries and receive notifications when orders are completed.</p>
          </div>
        </div>
      </section>
      
      <section className="wh-how-it-works">
        <h2>How It Works</h2>
        <div className="wh-steps">
          <div className="wh-step">
            <div className="wh-step-number">1</div>
            <h3>Choose Your Plan & Request Pickup</h3>
            <p>Select either our a la carte service (20% commission) or monthly subscription ($79/month with 15% commission). When a customer places a delivery order, submit a pickup request through our platform.</p>
          </div>
          <div className="wh-step-arrow">→</div>
          <div className="wh-step">
            <div className="wh-step-number">2</div>
            <h3>Driver Arrives</h3>
            <p>A licensed WeedHurry driver will arrive at your location within 30 minutes and purchase the items at either 80% or 85% of order value, depending on your plan. This commission covers the delivery service.</p>
          </div>
          <div className="wh-step-arrow">→</div>
          <div className="wh-step">
            <div className="wh-step-number">3</div>
            <h3>Delivery Completed</h3>
            <p>The driver delivers the order to your customer, collects payment, and sends confirmation when the transaction is complete. You keep track of all deliveries in your dashboard.</p>
          </div>
        </div>
      </section>
      
      <section className="wh-testimonials">
        <h2>What Our Partners Say</h2>
        <div className="wh-testimonial-grid">
          <div className="wh-testimonial">
            <p>"Weedhurry has allowed us to expand our delivery operations without hiring additional drivers. Our customers love the reliable service."</p>
            <div className="wh-testimonial-author">
              <strong>Jane Smith</strong>
              <span>Green Leaf Dispensary</span>
            </div>
          </div>
          <div className="wh-testimonial">
            <p>"We started with the a la carte option and switched to the subscription after seeing how many deliveries we were processing. The platform is intuitive and the drivers are professional."</p>
            <div className="wh-testimonial-author">
              <strong>Michael Johnson</strong>
              <span>Elevated Gardens</span>
            </div>
          </div>
        </div>
      </section>

     <section id="subscription-form">
       <CourierSubscriptionForm />
     </section>
     
      <section className="wh-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="wh-faq-items">
          <div className="wh-faq-item">
            <h3>Are all Weedhurry drivers licensed for cannabis delivery?</h3>
            <p>Yes, all of our drivers are fully licensed and compliant with state and local regulations for cannabis delivery.</p>
          </div>
          <div className="wh-faq-item">
            <h3>How quickly will a driver arrive after I request a pickup?</h3>
            <p>Our drivers typically arrive within 30 minutes of your pickup request, depending on current demand and your location.</p>
          </div>
          <div className="wh-faq-item">
            <h3>What's the difference between your two pricing plans?</h3>
            <p>Our a la carte plan charges a 20% commission on each delivery with no monthly fee. Our subscription plan costs $79/month but reduces the commission to 15%. The subscription plan is typically more cost-effective for dispensaries with higher delivery volumes.</p>
          </div>
          <div className="wh-faq-item">
            <h3>How does payment work?</h3>
            <p>Drivers purchase products from your dispensary at 80% (a la carte) or 85% (subscription) of the order total (before taxes). They collect the full payment from the customer upon delivery.</p>
          </div>
          <div className="wh-faq-item">
            <h3>Can I switch between the a la carte and subscription plans?</h3>
            <p>Yes, you can switch between plans at any time. Many partners start with the a la carte option and upgrade to the subscription as their delivery volume increases.</p>
          </div>
          <div className="wh-faq-item">
            <h3>What areas do you service?</h3>
            <p>We currently service major metropolitan areas in states with legal cannabis. Enter your address in the signup form to check if we operate in your area.</p>
          </div>
        </div>
      </section>
      
      <footer className="wh-footer">
        <div className="wh-footer-content">
          <div className="wh-footer-logo">
            <h2>Weedhurry</h2>
            <p>Fast, reliable cannabis delivery</p>
          </div>
          <div className="wh-footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Marketplace</a></li>
              <li><a href="#">Driver Applications</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          <div className="wh-footer-contact">
            <h3>Contact Us</h3>
            <p>Email: info@weedhurry.com</p>
            <p>Phone: (800) 810-8900</p>
          </div>
        </div>
        <div className="wh-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Weedhurry Inc. All rights reserved.</p>
          <p>
            <a href="/terms">Privacy Policy</a> | <a href="/terms">Terms of Service</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default WeedHurryCourier;